module.exports = __webpack_public_path__ + "media/images/third_party_logos/PGA_Middle_Atlantic_Section-58ddac4402009b611a95ccfc9cbdd456.png";